import React, { PureComponent, PropTypes } from 'react';

import Item from './Item';

export default class FilterItem extends PureComponent {
    static propTypes = {
        filterChanged: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.onFilterChanged = this.onFilterChanged.bind(this);
    }

    onFilterChanged(e) {
        const filter = e.currentTarget.value.length === 0 ? null : e.currentTarget.value;
        this.props.filterChanged(filter);
    }

    render() {
        return (
            <div className="select-list">
                <ul className="items">
                    <li className="item filter">
                        <input
                            type="text"
                            className="filter"
                            onChange={this.onFilterChanged}
                            placeholder="Filter...">
                        </input>
                        <span className="icon">
                            <i className="material-icons">&#xE8B6;</i>
                        </span>
                    </li>
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/SelectList/FilterItem.jsx